import React from 'react';

const NewArrowLeftIcon = ({ size = 34, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 34 34"
    fill="none"
    {...props}
  >
    <path
      d="M13.5575 26.6616C13.2884 26.6616 13.0192 26.5624 12.8067 26.3499L4.20754 17.7508C3.79671 17.3399 3.79671 16.6599 4.20754 16.2491L12.8067 7.64992C13.2175 7.23909 13.8975 7.23909 14.3084 7.64992C14.7192 8.06076 14.7192 8.74076 14.3084 9.15159L6.46004 16.9999L14.3084 24.8483C14.7192 25.2591 14.7192 25.9391 14.3084 26.3499C14.11 26.5624 13.8267 26.6616 13.5575 26.6616Z"
      fill="currentColor"
    />
    <path
      d="M29.0417 18.0625H5.19922C4.61839 18.0625 4.13672 17.5808 4.13672 17C4.13672 16.4192 4.61839 15.9375 5.19922 15.9375H29.0417C29.6226 15.9375 30.1042 16.4192 30.1042 17C30.1042 17.5808 29.6226 18.0625 29.0417 18.0625Z"
      fill="currentColor"
    />
  </svg>
);
export default NewArrowLeftIcon;
